export const plateValidation =
  /^[A-Z]{3}[0-9]{3}|[0-9]{3}[A-Z]{3}|[A-Z]{3}[0-9]{2}[A-Z]{1}|[A-Z]{3}[0-9]{2}|[R|T|S]{1}[0-9]{5}|[A-Z]{2}[0-9]{4}$/g;
